/**
 * Claim endpoints — request params + response shapes.
 *
 *   POST /v1/incidents/:publicId/claims                  — create (single or bulk)
 *   POST /v1/incidents/:publicId/claims/:claimPublicId/confirm
 *   POST /v1/incidents/:publicId/claims/:claimPublicId/reject
 *
 * Body schema for create lives in `./common.ts` as `CreateClaimBodySchema`
 * (re-exported here for convenience).
 */

import { z } from 'zod'

import { IncidentClaimSchema } from '../../schemas/entities/incident'

export {
  CreateClaimBodySchema,
  type CreateClaimBody,
  IncidentClaimResponseSchema,
  type IncidentClaimResponse
} from './common'

export const ClaimCreateParamsSchema = z.object({
  publicId: z.string().min(1)
})
export type ClaimCreateParams = z.infer<typeof ClaimCreateParamsSchema>

export const ConfirmClaimParamsSchema = z.object({
  publicId: z.string().min(1),
  claimPublicId: z.string().min(1)
})
export type ConfirmClaimParams = z.infer<typeof ConfirmClaimParamsSchema>

export const RejectClaimParamsSchema = z.object({
  publicId: z.string().min(1),
  claimPublicId: z.string().min(1)
})
export type RejectClaimParams = z.infer<typeof RejectClaimParamsSchema>

/**
 * Bulk claim response — when caller passes `participantIds`.
 */
export const IncidentClaimBulkResponseSchema = z.object({
  data: z.array(IncidentClaimSchema)
})
export type IncidentClaimBulkResponse = z.infer<typeof IncidentClaimBulkResponseSchema>
